export const CIRCLE = 'Circle';
